import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Collapse, Drawer } from 'antd'
import { FC, useState } from 'react'
import { helpItemsList } from './help-items-list'

const HelpDrawerList: FC = () => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Button type={'text'} icon={<QuestionCircleOutlined />} onClick={() => setOpen(true)}>
                Помощь
            </Button>

            <Drawer title={'Помощь'} width={1000} open={open} onClose={() => setOpen(false)}>
                <Collapse items={helpItemsList} ghost />
            </Drawer>
        </>
    )
}

export default HelpDrawerList
